/* global window $ */

import dayjs from 'dayjs'
import { hideNavBackdrop } from '$lib/navigation_backdrop_helper'
import AjaxSpinnerWidget from '../../ajax_spinner/script'

const REGISTER_LINK = '.js-open_register_modal'
const LOGIN_MODAL = '.js-modal-login'
const MODAL = '.js-modal-register'
const AGE_SELECTOR = '.js-modal-age-field'
const PARENT_EMAIL_FIELD_SELECTOR = '.js-modal-parent-email-field'
const TOGGLE_PARENT_EMAIL_FIELD_CLASS = 'input-field__input--inactive'
const SELECTIZE_SELECTOR = '.js-modal-selectize'
const PASSWORD_VISIBLE_EYE_CLASS = '.js-password-visibility'
const PASSWORD_FIELD_INPUT = '.modal__new_password'
const PASSWORD_FIELD_SELECTOR = '.js-password-field'
const FACEBOOK_LOGIN_SELECTOR = '.js-register-facebook'
const SUBMIT_BUTTON_SELECTOR = '.js-modal__submit--register'
const SIGN_UP_ROUTE = '/account/signup/'
const USER_MAIL_ICON_SELECTOR = '.user-at'
const PARENT_MAIL_ICON_SELECTOR = '.parent-at'
const USER_MAIL_INPUT_SELECTOR = '.js-modal__user_email'
const PARENT_MAIL_INPUT_SELECTOR = '.js-modal__parent_email'
const BIRTHDAY_CAKE_SELECTOR = '.js-cake'
const LOCK_ICON_SELECTOR = '.pw-lock'
const SELECTIZE_CONTROL_SELECTOR = '.selectize-control'

if (!window.selectize) {
  window.selectize = require('selectize')
}

const customParseFormat = require('dayjs/plugin/customParseFormat')

dayjs.extend(customParseFormat)

export default class ModalRegisterWidget {
  constructor() {
    const apprenticeRegisterLink = $(REGISTER_LINK)
    const modal = $(MODAL)
    const loginModal = $(LOGIN_MODAL)
    const passwordField = modal.find(PASSWORD_FIELD_SELECTOR)

    this.$namespace = $('.register__content')
    this.$parentEmailField = $(PARENT_EMAIL_FIELD_SELECTOR)
    this.$ageField = $(AGE_SELECTOR)
    this.$facebookLogin = $(FACEBOOK_LOGIN_SELECTOR)
    this.$submitButton = $(SUBMIT_BUTTON_SELECTOR)
    this.$userAtIcon = $(USER_MAIL_ICON_SELECTOR)
    this.$parentAtIcon = $(PARENT_MAIL_ICON_SELECTOR)
    this.$userMailInput = $(USER_MAIL_INPUT_SELECTOR)
    this.$parentMailInput = $(PARENT_MAIL_INPUT_SELECTOR)
    this.$birthdayCakeIcon = $(BIRTHDAY_CAKE_SELECTOR)
    this.$passwordFieldInput = $(PASSWORD_FIELD_INPUT)
    this.$lockIcon = $(LOCK_ICON_SELECTOR)
    $(SELECTIZE_SELECTOR).selectize()
    this.$selectize = $(SELECTIZE_SELECTOR)

    this.ajaxSpinner = new AjaxSpinnerWidget()

    this.showEmailFieldInitially()
    this.showFacebookLoginInitially()

    this.onUserMailInputListener()
    this.onParentMailInputListener()
    this.onPasswordFieldInputListener()

    this.onAgeListener()

    apprenticeRegisterLink.on('click', e => {
      e.preventDefault()
      e.stopPropagation()

      const dateString = $('.js-pre-date-of-birth').val()
      if (dateString) {
        const dateOfBirth = dayjs(dateString, 'DD.MM.YYYY')
        const age = dayjs().diff(dateOfBirth, 'years')

        $('js-modal-age-field').val(age)
        this.showOrHideU16Fields(age)
        $('.js-modal-age-field').hide()
        if ($('.js-dynamic-age-field').length > 0) {
          $('.js-dynamic-age-field').remove()
        }

        $('.js-modal-age-field')
          .parent()
          .append(
            "<input name='signup[age]' class='input-field__input modal__age js-dynamic-age-field' readonly=true type=text value='" +
              age +
              "'>"
          )
      }

      loginModal.hide()
      modal.css('display', 'flex')
    })

    this.$submitButton.on('click', e => {
      e.preventDefault()
      this.clearErrors()
      this.ajaxSpinner.showSpinner()
      this.$submitButton.addClass('js-hidden')

      const redirectUrl = $('.js-job-application-pre-form').data('redirect-url')
      let url = `/ajax${SIGN_UP_ROUTE}`

      if (redirectUrl) {
        url = `${url}?redirect_url=${redirectUrl}`
      }

      $.ajax({
        url,
        method: 'POST',
        data: this.getSerializedFormData()
      })
        .done(() => {
          // dont use cached document
          window.location.reload(true)
        })
        .fail(jqXHR => {
          this.ajaxSpinner.hideSpinner()
          this.$submitButton.removeClass('js-hidden')
          this.$submitButton.prop('disabled', false)
          this.$submitButton.html('Jetzt kostenlos registrieren')
          this.$submitButton.css('opacity', '1')
          // response is an object, so create an array from key-value pairs
          const errors = Object.entries(jqXHR.responseJSON.errors)
          this.addFieldError(errors)
        })
    })

    $('.js-register-modal-cross').on('click', e => {
      e.preventDefault()
      hideNavBackdrop()
      modal.hide()
    })

    // maybe obsolete
    $(PASSWORD_VISIBLE_EYE_CLASS).on('click', e => {
      e.preventDefault()
      if (passwordField.attr('type') === 'text') {
        passwordField.attr('type', 'password')
      } else {
        passwordField.attr('type', 'text')
      }
    })
  }

  addFieldError(errors) {
    errors.forEach(error => {
      const inputField = this.$namespace.find('form').find(`.modal__${error[0]}`)
      inputField.keypress(this.removeError)
      $(inputField.parent()).addClass('field_with_errors')

      // this breaks on password field. password input-element is wrapped insided another div.
      // also, the password live-validation is in the same location
      this.addErrorMessage(inputField.parent(), error[1])
    })
  }

  removeError() {
    $(this).off('keypress')
    const parentElement = $(this).parent()
    parentElement.removeClass('field_with_errors').find('span').remove()
  }

  addErrorMessage(element, messages) {
    messages.forEach(message => {
      element.append(`<span class="form-error-message">${message}</span>`)
    })
  }

  clearErrors() {
    const errorInputElements = this.$namespace.find('form').find('.field_with_errors')
    errorInputElements.removeClass('field_with_errors').find('.form-error-message').remove()
  }

  getSerializedFormData() {
    return this.$namespace.find('form').serialize()
  }

  onAgeListener() {
    this.$ageField.on('change', () => {
      if (this.$selectize[1].childNodes[0].classList.contains('full')) {
        this.$birthdayCakeIcon[0].classList.add('filled')
      } else {
        this.$birthdayCakeIcon[0].classList.remove('filled')
      }
      this.$ageField.parent().removeClass('field_with_errors').find('span').remove()
      this.showOrHideU16Fields(this.$ageField.val())
    })
  }

  showEmailFieldInitially() {
    if (this.$ageField.val() === '' || parseInt(this.$ageField.val(), 10) >= 16) {
      this.hideParentEmailField()
    } else {
      this.showParentEmailField()
    }
  }

  showFacebookLoginInitially() {
    if (this.$ageField.val() === '' || parseInt(this.$ageField.val(), 10) < 16) {
      this.$facebookLogin.hide()
    } else {
      this.$facebookLogin.show()
    }
  }

  showOrHideU16Fields(age) {
    if (age === '') {
      this.hideParentEmailField()
      this.$facebookLogin.hide()
    } else if (parseInt(age, 10) < 16) {
      this.showParentEmailField()
      this.$facebookLogin.hide()
    } else {
      this.hideParentEmailField()
      this.$facebookLogin.show()
    }
  }

  hideParentEmailField() {
    if (!this.$parentEmailField.hasClass(TOGGLE_PARENT_EMAIL_FIELD_CLASS)) {
      this.$parentEmailField.addClass(TOGGLE_PARENT_EMAIL_FIELD_CLASS)
    }
  }

  showParentEmailField() {
    if (this.$parentEmailField.hasClass(TOGGLE_PARENT_EMAIL_FIELD_CLASS)) {
      this.$parentEmailField.removeClass(TOGGLE_PARENT_EMAIL_FIELD_CLASS)
    }
  }

  onUserMailInputListener() {
    this.$userMailInput.on('input', () => {
      this.$userAtIcon.toggleClass('filled', this.$userMailInput[0].value.length > 0)
    })
  }

  onParentMailInputListener() {
    this.$parentMailInput.on('input', () => {
      this.$parentAtIcon.toggleClass('filled', this.$parentMailInput[0].value.length > 0)
    })
  }

  onPasswordFieldInputListener() {
    this.$passwordFieldInput.on('input', () => {
      // Since 'this.$passwordFieldInput[0].value.length' always returns
      // 0 it is not possible to toggle the color when the input is deleted
      this.$lockIcon[0].classList.add('filled')
    })
  }
}
